define('views/register/bulk/register',[
	'backbone',
	'views/_base/baseview',
	'text!views/register/bulk/register.html',
	'text!views/register/bulk/register_rxsavings.html',
	'text!views/register/bulk/register_proteus.html',
	'text!views/register/bulk/register_alahealth.html',
	'views/shared/form/form_component',
	'views/shared/list/icon_list',
	'views/shared/grid/grid',
	'views/shared/phone/phone_carousel',
	'models/user/register/status',
	'views/shared/gpr/offer',
	'views/shared/registration/howitworks',
	'views/root/join',
	'views/root/disclaimer',
	'models/user/register/bulk_register',
	'deepmerge',
], function (
	Backbone,
	BaseView,
	Template,
	RxsavingsTemplate,
	ProteusTemplate,
	AlaHealthTemplate,
	FormComponent,
	IconListComponent,
	GridComponent,
	PhoneCarousel,
	SimpleRegStatus,
	GPROfferComponent,
	HowItWorksComponent,
	JoinComponent,
	DisclaimerComponent,
	BulkRegisterModel,
	Merge
) {
	'use strict';

	return BaseView.extend({
		className: 'bulk-register-container',
		tagName: 'div',
		isRender: true,
		events: {},

		initialize: function (options) {
			options = options || {};

			this.site_version = pf.getContent('version.id');

			this.bulk_registration_form_content = pf.getContent(
				'register.content.form.bulk'
			);

			this.bulk_registration_content = pf.getContent('register.content.bulk');

			this.is_valid_email = true;

			if (
				this.site_version == enums.siteVersion.bcbssc ||
				this.site_version == enums.siteVersion.rxsavings ||
				this.site_version == enums.siteVersion.proteus ||
				this.site_version == enums.siteVersion.csnp ||
				this.site_version == enums.siteVersion.centene ||
				this.site_version == enums.siteVersion.bcbskc
			) {
				var feature_set_id = enums.registrationSetId.regular_subscriber_id;
			} else {
				var feature_set_id = enums.registrationSetId.evive;
			}

			var form_id = enums.registrationId.regular,
				form_options = {
					set_id: feature_set_id,
					id: enums.registrationId.social,
					depth: 2,
				};

			this.bulk_registration = pf.getFeatureBySetId(feature_set_id);

			// this.bulk_registration = pf.getFeatureById(form_id, form_options);

			// Temporary
			this.bulk_registration = this.bulk_registration_form_content;

			this.user_data = {};

			this.simple_reg_status_interval = null;
			this.status_invterval_count = 0;

			this.response_token = null;

			this.bulk_registration_form = null;

			this.registration_id = options.registration_id;

			this.elementName = options.elementName;

			if (
				this.site_version !== enums.siteVersion.alahealth &&
				this.site_version !== enums.siteVersion.csnp &&
				this.site_version !== enums.siteVersion.almyblue &&
				this.site_version !== enums.siteVersion.centene &&
				this.site_version !== enums.siteVersion.bcbskc
			) {
				startPanoScrollAnimator('.bulk-register-content-container', 0.25);
			}

			// console.log('Bulk Registration', this);

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this,
				template = null;

			if (this.site_version == enums.siteVersion.rxsavings) {
				template = _.template(RxsavingsTemplate);
			} else if (this.site_version == enums.siteVersion.proteus) {
				template = _.template(ProteusTemplate);
			} else if (this.site_version == enums.siteVersion.alahealth) {
				template = _.template(AlaHealthTemplate);
			} else {
				template = _.template(Template);
			}

			this.$el.addClass(pf.getContent('version.name')).html(template());

			if (
				this.bulk_registration_form_content.type ==
				enums.bulkRegistrationType.standard
			) {
				// Add header content
				this.addHeaderContent();
			}

			// Add the bulk registration form
			this.addRegistrationForm();

			var site_versions_gpr = [
				enums.siteVersion.bcbssc,
				enums.siteVersion.rxsavings,
				enums.siteVersion.proteus,
				enums.siteVersion.bcbsal,
				enums.siteVersion.alahealth,
				enums.siteVersion.csnp,
				enums.siteVersion.centene,
				enums.siteVersion.almyblue,
				enums.siteVersion.bcbskc,
			];

			if (site_versions_gpr.includes(this.site_version)) {
				// GPR Offer
				this.addGPROffer();
			} else {
				// Add Merchant Logos
				this.addMerchantLogos();

				// Add How Payment Works
				this.addHowPaymentWorks();

				// Add How It Works
				this.addHowItWorks();
			}

			// Add Phone Carousel
			this.addPhoneCarousel();

			// Adjust header
			this.createAccountExceptions();

			// Add Disclaimers
			this.addDisclaimers();

			// Check eligibility
			this.checkForPasswordChangeEligibility();

			return this;
		},

		loadData: function () {},

		addGPROffer: function () {
			var gpr_offer = new GPROfferComponent({
				elementName: '.js-gpr-offer-container',
			});
		},

		addHeaderContent: function () {
			if (
				this.bulk_registration_form_content.type ==
				enums.bulkRegistrationType.greeting
			) {
				var first_name = this.user_data.FN
						? this.user_data.FN.charAt(0).toUpperCase() +
						  this.user_data.FN.slice(1) +
						  ', '
						: '',
					header_copy = pf
						.getContent('register.content.form.bulk.top_header')
						.replace('{{FN}}', first_name),
					html =
						'<h1 class="bulk-register-header-copy js-bulk-register-header-copy">' +
						header_copy +
						'</h1>';

				var evive_html = `<div class="evive-hdr-wrap"><h1 class="evive-bulk-hdr">${header_copy}</h1><p class="evive-bulk-text">Once registered, you can:</p><p class="evive-bulk-text">Request a PayForward pre-paid debit card to use anywhere Visa&reg; is accepted</p><p class="evive-bulk-text"><b style="text-decoration: underline;">or</b></p><p class="evive-bulk-text">Link your bank account to transfer the money</p></div>`;

				this.$('.js-bulk-register-header').html(
					this.site_version === enums.siteVersion.payforward ? evive_html : html
				);
			} else {
				if (this.site_version === enums.siteVersion.almyblue) {
					var container = document.createElement('div'),
						header = document.createElement('h1'),
						logo_container = document.createElement('div'),
						logo = pf.getContent('global.logo.rewards'),
						version_name = pf.getContent('version.name');

					logo_container.className = 'header-partner-logo';
					logo_container.innerHTML = logo;
					header.innerHTML = pf.getContent(
						'landing.content.pano.header',
						'string'
					);

					container.className = 'header-marketing-container';
					container.style.backgroundImage =
						"url('img/registration/_versions/almyblue/bulk-reg-top.png')";
					container.appendChild(logo_container);
					container.appendChild(header);

					this.$('.js-bulk-register-header').html(container);
				} else if (this.site_version === enums.siteVersion.bcbsal) {
					var container = document.createElement('div'),
						logo_container = document.createElement('div'),
						logo = enums.svg.bcbsalLogo,
						marketing_image = document.createElement('img'),
						marketing_image_mobile = document.createElement('img'),
						version_name = pf.getContent('version.name'),
						file_name = pf.getContent(
							'register.content.bulk.pano.marketing_image'
						),
						file_name_mobile = pf.getContent(
							'register.content.bulk.pano.marketing_image_mobile'
						);

					marketing_image.className = 'marketing-image';
					marketing_image.src =
						'img/registration/_versions/' + version_name + '/' + file_name;

					marketing_image_mobile.className = 'marketing-image-mobile';
					marketing_image_mobile.src =
						'img/registration/_versions/' +
						version_name +
						'/' +
						file_name_mobile;

					logo_container.className = 'header-partner-logo';
					logo_container.innerHTML = logo;

					container.className = 'header-marketing-container';
					container.appendChild(logo_container);
					container.appendChild(marketing_image);
					container.appendChild(marketing_image_mobile);

					this.$('.js-bulk-register-header').html(container);
				} else {
					if (this.site_version !== enums.siteVersion.alahealth) {
						var logo = document.createElement('img'),
							version_name = pf.getContent('version.name'),
							file_name = pf.getContent('register.content.bulk.pano.logo');

						logo.src =
							'img/registration/_versions/' + version_name + '/' + file_name;

						this.$('.js-bulk-register-header').html(logo);
					}
				}
			}
		},

		addRegistrationForm: function () {
			var that = this,
				form_fields = pf.getContent('register.content.form.bulk.fields'),
				button_data = pf.getContent(
					'register.content.form.bulk.button_component'
				),
				route = pf.getContent('register.content.form.bulk.route');

			// this is a TEMP solution to override the functionality of a muted email field if IVE: false
			if (!this.is_valid_email) {
				for (var i = 0; i < form_fields.length; i++) {
					if (form_fields[i].input_type == 'email') {
						form_fields[i]['component_type'] = 4;
						form_fields[i].error = {
							empty: 'Please enter an email address.',
							invalid: 'Please enter a valid email address.',
							exists:
								'This email address is already associated with another account.',
						};
					}
				}
			}

			if (_.isObject(this.bulk_registration)) {
				this.bulk_registration_form = new FormComponent({
					elementName: '.js-register-form',
					button_data: button_data,
					route: route,
					// feature    : this.bulk_registration,
					// content_fields: form_fields,
					fields: form_fields,
					// form_type  : enums.formType.features,
					form_type: enums.formType.standard,
					validated: function (fields, confirm) {
						// console.log('addRegistrationForm validated:',confirm.name);

						that.completeRegistration();
					},
					success: function (end) {
						// console.log('addRegistrationForm success:',end);

						that.nextStep();
					},
					error: function (errors) {
						// console.log('addRegistrationForm error:',errors);
						// that.registrationError();
						// Temporary
						// that.nextStep();
					},
				});
			}
		},

		registrationError: function (errors) {
			console.log('registrationError', errors);
		},

		completeRegistration: function () {
			var that = this,
				form_data = this.bulk_registration_form.getFieldValues();

			var data = Merge(this.user_data, form_data);

			if (
				this.bulk_registration_form_content.type ==
				enums.bulkRegistrationType.standard
			) {
				data.instanceURL = pf.userURL + 's/Wellness';
			}

			if (
				this.site_version == enums.siteVersion.bcbsal ||
				this.site_version == enums.siteVersion.proteus ||
				this.site_version == enums.siteVersion.alahealth ||
				this.site_version == enums.siteVersion.almyblue
			) {
				if (!data.MemberID) {
					data.MemberID = 'NA';
				}
			}

			this.bulk_register_model = new BulkRegisterModel(data);

			this.bulk_register_model.save(null, {
				success: function (model, resp, options) {
					// console.log('bulk_register_model success', model, resp, options);

					that.response_token = resp;

					if (
						that.bulk_registration_form_content.type ==
						enums.bulkRegistrationType.standard
					) {
						// Temporarily placed here, but should happen after the status interval is completed
						if (
							_.isFunction(that.bulk_registration_form.acknowledgedValidation)
						) {
							that.bulk_registration_form.acknowledgedValidation(true);
						}
					} else {
						// Start interval to check on the Create PW process, this needs to happen before we navigate member to their wallet
						that.startStatusInterval();
					}
				},
				error: function (model, response, options) {
					// console.log('bulk_register_model error', model, response, options);

					if (response.status == 409) {
						if (_.isFunction(that.bulk_registration_form.updateErrorMessage)) {
							that.bulk_registration_form.updateErrorMessage(
								pf.getContent('register.content.form.bulk.error.non_match')
							);
						}

						// console.log('409 ERROR',_.isFunction(that.bulk_registration_form.showInlineTopErrorMessage));

						if (
							_.isFunction(
								that.bulk_registration_form.showInlineTopErrorMessage
							)
						) {
							that.bulk_registration_form.showInlineTopErrorMessage();
						}

						// Show the field that is incorrect (MemberID)
						that.bulk_registration_form.showFieldError(
							enums.formComponentTypes.member_id,
							true
						);

						if (
							_.isFunction(that.bulk_registration_form.acknowledgedValidation)
						) {
							that.bulk_registration_form.acknowledgedValidation(false);
						}
					} else {
						if (
							_.isFunction(that.bulk_registration_form.acknowledgedValidation)
						) {
							that.bulk_registration_form.acknowledgedValidation(false);
						}
					}
				},
			});
		},

		nextStep: function () {
			var that = this,
				form = pf.getContent('register.content.form.bulk');

			if (this.response_token) {
				pf.session.saveToken(this.response_token);
			}

			// console.log('Bulk registration nextStep', form.route, form, this.response_token, pf.session);

			// Temporary routing.  We will do this after polling and route is dependent on client.
			if (form.route) {
				pf.navigate(form.route);

				// pf.navigate(form.route, { trigger: false });

				// pf.require('views/register/address_confirmation', null, null, true, function(){
				//     require(['views/register/address_confirmation'], function(Register){
				//         pf.show(new Register({ elementName: '#mainRegion', response_token: that.response_token }));
				//     });
				// });
			}
		},

		/*
			Inherited Bulk Registration
		*/

		addMerchantLogos: function () {
			var logos = pf.getContent('landing.content.logos'),
				icon_list = new IconListComponent({
					elementName: '.js-merchant-icon-container',
					icons: logos,
				});

			this.$el.find('.js-merchant-icon-container').css({ opacity: 1 });
		},

		addPhoneCarousel: function () {
			if (this.site_version == enums.siteVersion.payforward) {
				var phone_items = pf.getContent('landing.content.phone.items');
			} else if (
				this.site_version == enums.siteVersion.rxsavings ||
				this.site_version == enums.siteVersion.proteus ||
				this.site_version == enums.siteVersion.csnp ||
				this.site_version == enums.siteVersion.centene ||
				this.site_version == enums.siteVersion.bcbskc
			) {
				var phone_items = pf.getContent('register.content.bulk.phone.items');
			}

			var phone_carousel = new PhoneCarousel({
				elementName: '.js-phone-carousel',
				items: phone_items,
			});
		},

		addHowPaymentWorks: function () {
			var how_payment_it_works = new HowItWorksComponent({
				elementName: '.js-how-payment-works-container',
			});
		},

		addHowItWorks: function () {
			var how_it_works = new GridComponent({
				elementName: '.js-how-it-works',
				grid: pf.getContent('landing.content.grid'),
			});
		},

		addDisclaimers: function () {
			var join_ad = new DisclaimerComponent({
				elementName: '.js-disclaimer-container',
			});
		},

		checkForPasswordChangeEligibility: function () {
			var that = this;

			if (this.registration_id) {
				$.ajax({
					type: 'GET',
					url: pf.userURL + '/SimpleRegistration/' + this.registration_id,
					async: false,
					contentType: 'application/json',
					success: function (resp) {
						// console.log('checkForPasswordChangeEligibility success',resp);

						that.user_data = resp.User;
						that.is_valid_email = that.user_data.IVE;

						// Add user's email to the form
						if (that.bulk_registration_form && that.user_data.IVE) {
							that.bulk_registration_form.updateFieldValue(
								enums.formComponentTypes.email_mute,
								that.user_data.E
							);
						}

						if (!that.user_data.IVE) {
							that.addRegistrationForm();
						}

						// if IVE false, override muted text field from content
						// if (that.bulk_registration_form && !that.user_data.IVE) {
						//     that.$('[type=email]').removeClass('mute').attr('disabled', false);
						// }

						// Add user's first name to the form
						if (that.bulk_registration_form) {
							that.bulk_registration_form.updateFieldValue(
								enums.formComponentTypes.first_name,
								that.user_data.FN,
								enums.formComponentTypes.first_name
							);
						}

						// Add user's last name to the form
						if (that.bulk_registration_form) {
							that.bulk_registration_form.updateFieldValue(
								enums.formComponentTypes.last_name,
								that.user_data.LN,
								enums.formComponentTypes.last_name
							);
						}

						if (
							that.bulk_registration_form_content.type ==
							enums.bulkRegistrationType.greeting
						) {
							// Add header content
							that.addHeaderContent();
						}

						// // This applies to BCBSLA only
						// if(that.user_data.OIWP || that.site_version == enums.siteVersion.bcbsla){
						//     that.$('.js-bcbsla-optin').show();
						// }
					},
					error: function (error) {
						// console.log('checkForPasswordChangeEligibility error',error);

						pfdialog.alert({
							context: this,
							Title: 'Account Found',
							Body: 'Your account has already been registered. Log in to continue.',
							okCallback: function () {
								pf.navigate('login');
							},
						});

						// Re-render the header to undo all of the adjustments specifically made for this page
						if (_.isObject(pf.header)) {
							pf.header.render();
						}
					},
				});
			}
		},

		createAccountExceptions: function () {
			$('#header-inner-container .user-links').hide();

			$('#pf-logo').on('click', function () {
				window.location.href = '';
			});
		},

		startStatusInterval: function () {
			var that = this;

			this.simple_reg_status_interval = setInterval(function () {
				if (that.status_invterval_count < 24) {
					// Call the polling endpoint
					that.checkSimpleRegStatus();
				} else {
					clearInterval(that.simple_reg_status_interval);

					if (
						_.isFunction(that.bulk_registration_form.acknowledgedValidation)
					) {
						that.bulk_registration_form.acknowledgedValidation(false);
					}
				}
			}, 5000);
		},

		checkSimpleRegStatus: function () {
			var that = this;

			this.simple_reg_status_check = new SimpleRegStatus({
				UG: this.user_data.UG,
			});

			this.simple_reg_status_check.fetch({
				success: function (modelStatus, respStatus, options) {
					that.status_invterval_count = that.status_invterval_count + 1;

					// console.log('checkSimpleRegStatus', options.xhr.status, modelStatus, respStatus, options);

					// 202: Processing, 200: Good
					if (options.xhr.status == 200) {
						clearInterval(that.simple_reg_status_interval);

						$('#header-content').css('visibility', 'visible');

						if (
							_.isFunction(that.bulk_registration_form.acknowledgedValidation)
						) {
							that.bulk_registration_form.acknowledgedValidation(true);
						}
					} else if (options.xhr.status == 412) {
						saveCipTriggerRoute('home');

						pf.navigate('register/financial/cip', { trigger: true });
					}
				},
				error: function (modelStatus, respStatus, options) {
					clearInterval(that.simple_reg_status_interval);

					if (options.xhr.status == 412) {
						$('#header-content').css('visibility', 'visible');

						if (
							_.isFunction(that.bulk_registration_form.acknowledgedValidation)
						) {
							that.bulk_registration_form.acknowledgedValidation(true);
						}

						saveCipTriggerRoute('home');

						pf.navigate('register/financial/cip', { trigger: true });
					} else {
						if (
							_.isFunction(that.bulk_registration_form.acknowledgedValidation)
						) {
							alert('registration form error');
							that.bulk_registration_form.acknowledgedValidation(false);
						}
					}
				},
			});
		},

		close: function () {
			endPanoScrollAnimator();
		},
	});
});

